import { useState } from "react";
import AnimateHeight from "react-animate-height";
import { translations } from "../../../../constans/languagesList";
import { formatDateAndTime } from "../../../../utils/dateActions";
import { LogEntry } from "../SessionInfoBlock/SessionInfoBlock";
import s from "./SessionLogs.module.css";

type SessionLogsProps = {
  entry: LogEntry;
  sessionDuration?: { user: string; totalSessionTime: number }[];
};

const SessionLogs = ({ entry, sessionDuration }: SessionLogsProps) => {
  const [logsIsOpen, setLogsIsOpen] = useState(false);

  const formatMilliseconds = (milliseconds: number): string => {
    const { hours, minutes, seconds } = translations["en"];
    const secs = Math.floor((milliseconds / 1000) % 60);
    const mins = Math.floor((milliseconds / (1000 * 60)) % 60);
    const hrs = Math.floor(milliseconds / (1000 * 60 * 60));
    return `${hrs}${hours} ${mins}${minutes} ${secs}${seconds}`;
  };

  const totalTime = sessionDuration?.find(
    (el) => el.user === entry.participant.userId,
  )?.totalSessionTime;

  return (
    <div className={s.userLogsElementBlock}>
      <div className={s.userTimeLogsHeadBlock}>
        <h3 className={s.participantName}>{entry.participant.name}</h3>
        <div className={s.durationElement}>
          <span>Time in session:</span>
          <span className={s.userTotalTime}>
            {totalTime != null ? formatMilliseconds(totalTime) : "-"}
          </span>
        </div>
      </div>
      <AnimateHeight height={logsIsOpen ? "auto" : 0}>
        <ul className={s.logsList}>
          {entry.logs.map((log, index) => (
            <li key={index} className={s.logItem}>
              <div className={s.flexRowBlock}>
                <span className={s.label}>Join time:</span>
                <span className={s.time}>
                  {
                    formatDateAndTime(new Date(log.joinTime), "en")
                      .formattedTime
                  }
                </span>
              </div>
              <div className={s.flexRowBlock}>
                <span className={s.label}>Leave time:</span>
                <span className={s.time}>
                  {log.leaveTime
                    ? formatDateAndTime(new Date(log.leaveTime), "en")
                        .formattedTime
                    : "Still in session"}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </AnimateHeight>
      <div
        className={s.collapseBtn}
        role="button"
        onClick={() => setLogsIsOpen((prev) => !prev)}
      >
        {logsIsOpen ? "Collapse" : "Expand"}
      </div>
    </div>
  );
};

export default SessionLogs;
